module.exports = __webpack_public_path__ + "media/founders.bf0edb7f.mp4";